export default "__VITE_ASSET__Cyfqpd9w__"